// -------------------------------
// EARNING INTERFACES
// -------------------------------
export interface PendingEarning {
  Name?: string;
  calculationType?: "percentage" | "amount";
  CalculatedUpon?: string;
  Percent?: string;
  Amount?: string;
  UnitOfCalculation?: string;
  Description?: string;
}

export interface PendingDeleteEarning {
  awaitingName?: boolean;
}

export const startCreateEarningFlow = (
  setPending: (data: PendingEarning | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void,
  nameFromIntent?: string
) => {
  if (nameFromIntent) {
    setPending({ Name: nameFromIntent });
    pushAIChat(`Is this earning percentage based or absolute?`);
    speak(`Is this earning percentage based or absolute?`);
    return;
  }

  setPending({});
  pushAIChat("What should the earning be called?");
  speak("What should the earning be called?");
};

export const processPendingEarning = (
  text: string,
  pending: PendingEarning,
  setPending: (data: PendingEarning | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void
) => {

  // STEP 1 — Name
  if (!pending.Name) {
    setPending({ ...pending, Name: text });
    pushAIChat("Is this earning percentage based or absolute?");
    speak("Is this earning percentage based or absolute?");
    return;
  }

  // STEP 2 — Calculation Type
  if (!pending.calculationType) {
    const type = text.toLowerCase().includes("percent")
      ? "percentage"
      : "amount";

    setPending({ ...pending, calculationType: type });

    if (type === "percentage") {
      pushAIChat("Which earning is this calculated upon?");
      speak("Which earning is this calculated upon?");
    } else {
      pushAIChat("What is the fixed amount?");
      speak("What is the fixed amount?");
    }
    return;
  }

  // STEP 3 — Calculated Upon
  if (pending.calculationType === "percentage" && !pending.CalculatedUpon) {
    setPending({ ...pending, CalculatedUpon: text });
    pushAIChat("What percentage should be applied?");
    speak("What percentage should be applied?");
    return;
  }

  // STEP 4 — Percent
  if (pending.calculationType === "percentage" && !pending.Percent) {
    setPending({ ...pending, Percent: text });
    pushAIChat("Any description for this earning?");
    speak("Any description?");
    return;
  }

  // STEP 5 — Amount
  if (pending.calculationType === "amount" && !pending.Amount) {
    setPending({ ...pending, Amount: text });
    pushAIChat("Any description for this earning?");
    speak("Any description?");
    return;
  }

  // STEP 6 — Description → FINAL
  if (!pending.Description) {
    const finalData = {
      ...pending,
      Description: text,
    };

    pushAIChat(`Creating earning "${pending.Name}"...`);
    speak(`Creating earning ${pending.Name}.`);

    window.dispatchEvent(
      new CustomEvent("ai-create-earning", {
        detail: finalData,
      })
    );

    setPending(null);
  }
};

export const startDeleteEarningFlow = (
  setPendingDelete: (data: PendingDeleteEarning | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void,
  nameFromIntent?: string 
) => {
  if (nameFromIntent) {
    pushAIChat(`Deleting earning "${nameFromIntent}"...`);
    speak(`Deleting earning ${nameFromIntent}.`);

    window.dispatchEvent(
      new CustomEvent("ai-delete-earning", {
        detail: { name: nameFromIntent }
      })
    );
    return;
  }

  setPendingDelete({ awaitingName: true });
  pushAIChat("Which earning would you like to delete?");
  speak("Which earning would you like to delete?");
};

export const processPendingDeleteEarning = (
  text: string,
  pending: PendingDeleteEarning,
  setPendingDelete: (data: PendingDeleteEarning | null) => void,
  pushAIChat: (msg: string) => void,
  speak: (msg: string) => void
) => {
  if (!pending.awaitingName) return;

  pushAIChat(`Deleting earning "${text}"...`);
  speak(`Deleting earning ${text}.`);

  window.dispatchEvent(
    new CustomEvent("ai-delete-earning", {
      detail: { name: text }
    })
  );

  setPendingDelete(null);
};
